import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

const prepareDataTable = data => {
  const dataTable = [];

  data.forEach(item => {
    const el = {
      key: item.id,
      id: item.id,
      user: {
        uuid: item.invited.uuid,
        name: item.invited.name
      },
      status: item.status,
      operations: item
    };
    dataTable.push(el);
  });

  return dataTable;
};

function* getUnmaskingInvitations({ payload: { signal, curr_page } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.unmasking.invitations.list,
      params: { page: curr_page },
      signal
    });

    const preparedData = {
      dataTable: prepareDataTable(data.results),
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getUnmaskingInvitationsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getUnmaskingInvitationsFailed,
      endpoint: api.unmasking.invitations.list.url
    });
  }
}

export const getUnmaskingInvitationsSaga = takeEvery(types.GET_UNMASKING_INVITATIONS_REQUEST, getUnmaskingInvitations);